module.exports = __webpack_public_path__ + "img/vg.vg621c3ad.svg";